// extracted by mini-css-extract-plugin
export default {"swiper-container":"esN2mL","swiper-container--align-center":"_CfPbj","paginate-padding":"MBdy5A","slide-width-auto":"USEqkr","swiper-slide":"TTQcMm"};